module.exports = __webpack_public_path__ + "img/language.53e66fe3.svg";